export function parseArchiveQuery(search, appliedFilters = []) {
    const params = new URLSearchParams(search || '');
    const request = {
        brands: [],
        categories: [],
        attributes: [],
        min_price: params.get('min_price') ? Number(params.get('min_price')) : null,
        max_price: params.get('max_price') ? Number(params.get('max_price')) : null,
        orderby: params.get('orderby') || 'default',
        page: params.get('page') ? Number(params.get('page')) : null,
        search: params.get('search') || null,
        stock_status: params.get('stock_status') === '1',
        special_offers: params.get('special_offers') === '1',
    };

    if (params.get('brands')) {
        request.brands = params.get('brands').split(',').map(Number).filter(Boolean);
    }
    if (params.get('categories')) {
        request.categories = params.get('categories').split(',').map(Number).filter(Boolean);
    }
    if (params.get('attributes')) {
        request.attributes = params.get('attributes').split(',').map(Number).filter(Boolean);
    }

    appliedFilters.forEach((appliedFilter) => {
            if (appliedFilter.type === 'brand' && !params.get('brands')) {
                request.brands = appliedFilter.filters.map((filter) => Number(filter.id));
            }
            if (appliedFilter.type === 'attribute' && !params.get('attributes')) {
                request.attributes = appliedFilter.filters.map((filter) => Number(filter.entity_id));
            }
            if (appliedFilter.type === 'search' && !params.get('search')) {
                request.search = appliedFilter.filters || null;
            }
            if (appliedFilter.type === 'stock_status') {
                request.stock_status = appliedFilter.filters === true;
            }
            if (appliedFilter.type === 'special_offers') {
                request.special_offers = appliedFilter.filters === true;
            }
            if (appliedFilter.type === 'min_price' && !params.get('min_price')) {
                request.min_price = Number(appliedFilter.filters);
            }
            if (appliedFilter.type === 'max_price' && !params.get('max_price')) {
                request.max_price = Number(appliedFilter.filters);
            }
        });

    return request;
}

export function buildArchiveQuery(request) {
    const query = [];

    Object.entries(request).forEach(([key, value]) => {
        if (key === 'trigger') {
            return;
        }
        if (value === null || value === undefined || value === '') {
            return;
        }
        if (Array.isArray(value)) {
            if (value.length) {
                query.push(`${encodeURIComponent(key)}=${value.join(',')}`);
            }
            return;
        }
        if (typeof value === 'boolean') {
            if (value) {
                query.push(`${encodeURIComponent(key)}=1`);
            }
            return;
        }
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });

    return query.join('&');
}
